<template>
  <div id="header">
    <div class="bg d-block d-md-none" />
    <img alt="x-bg" src="../assets/images/x-bg.png" class="x-bg d-block d-md-none" />
    <div class="container">
      <div class="row d-flex d-md-none">
        <div class="col-12">
          <button type="button" class="icon" @click="goToHome()">
            <ChevronLeft />
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 title">
          <h1>Documentos Fideicomiso</h1>
        </div>
        <div class="col-6 d-none d-md-flex title">
          <button type="button" class="icon times" @click="goToHome()">
            <Times />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronLeft from '../assets/icons/chevron-left.svg';
import Times from '../assets/icons/times-o.svg';

export default {
  name: 'FideicomisoHeader',
  components: {
    ChevronLeft,
    Times,
  },
  props: {
    closeSidepanel: Function,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    goToHome() {
      this.closeSidepanel();
    },
  },
};
</script>

<style scoped lang="scss">
#header {
  width: 100%;
  overflow: hidden;
}
.icon {
  position: relative;
  float: left;
  margin: 0;
  margin-top: 25px;
  margin-left: -5px;
  background: none;
  border: none;
  padding: 0;
  width: 34px;
  cursor: pointer;

  &.times {
    margin: 0;
    right: 45px;
    position: absolute;
  }
}
.bg {
  width: 100%;
  height: 193px;
  background: #330e2f;
  border-radius: 0px 0px 30px 30px;
  position: absolute;
  top: 0;
  left: 0;
}
.title {
  margin-top: 55px;
}
h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
  line-height: 1.1;

  @media (min-width: 768px) {
    max-width: 267px;
    color: #330e2f;
    margin-top: 0;
    margin-left: 15px;
    line-height: 1.3;
  }
}

.x-bg {
  position: absolute;
  right: -35px;
  top: 89px;
  max-height: 95px;
}
</style>
